import { render } from "./SubDeterminantBadge.vue?vue&type=template&id=597cbbe6&scoped=true&ts=true"
import script from "./SubDeterminantBadge.ts?vue&type=script&lang=ts&external"
export * from "./SubDeterminantBadge.ts?vue&type=script&lang=ts&external"

import "./SubDeterminantBadge.scss?vue&type=style&index=0&id=597cbbe6&lang=scss&scoped=true&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-597cbbe6"]])

export default __exports__